export default __webpack_public_path__ + "static/media/fish.919f3a60.webp";